import React from 'react';

const BANDS = [
  { label: 'SLOW', max: 350, color: '#00E5FF' },
  { label: 'NORMAL', max: 500, color: '#34C759' },
  { label: 'ELEVATED', max: 700, color: '#FF9F0A' },
  { label: 'EXTREME', max: 1200, color: '#FF3B30' },
];

export default function SolarWindGauge({ insights }) {
  // Find solar wind data from insights
  const swInsight = insights?.find(i =>
    i.sources?.includes('SWPC Solar Wind') && !i.is_offline
  );
  const dp = swInsight?.data_points || {};
  const speed = dp.speed_km_s || 0;
  const density = dp.density_p_cm3 || 0;
  const temp = dp.temperature_k || null;
  const speedClass = dp.speed_class || 'unknown';
  const isStale = swInsight?.is_offline || !swInsight;

  // Gauge fill position (0-100%)
  const maxSpeed = 1200;
  const pct = Math.min((speed / maxSpeed) * 100, 100);

  // Band color
  let bandColor = '#52525B';
  for (const b of BANDS) {
    if (speed <= b.max) { bandColor = b.color; break; }
  }

  return (
    <div className="orion-gauge" data-testid="solar-wind-gauge">
      <div className="orion-gauge-header">
        <span className="orion-gauge-title">SOLAR WIND</span>
        {isStale && <span className="orion-stale-badge" data-testid="solar-wind-stale">STALE</span>}
      </div>

      <div className="orion-gauge-main">
        <div className="orion-gauge-value" style={{ color: bandColor }} data-testid="solar-wind-speed">
          {speed > 0 ? speed.toFixed(0) : '—'}
        </div>
        <div className="orion-gauge-unit">km/s</div>
      </div>

      <div className="orion-gauge-bar">
        <div className="orion-gauge-bar-track">
          {BANDS.map((b, i) => (
            <div key={i} className="orion-gauge-band" style={{
              width: `${((b.max - (i > 0 ? BANDS[i-1].max : 0)) / maxSpeed) * 100}%`,
              background: `${b.color}20`,
            }} />
          ))}
          <div className="orion-gauge-bar-fill" style={{ width: `${pct}%`, background: bandColor }} />
        </div>
        <div className="orion-gauge-labels">
          {BANDS.map((b, i) => (
            <span key={i} style={{ color: b.color, fontSize: '7px', fontFamily: 'var(--o-mono)' }}>{b.label}</span>
          ))}
        </div>
      </div>

      <div className="orion-gauge-sub">
        <div className="orion-gauge-sub-item">
          <span className="orion-gauge-sub-label">DENSITY</span>
          <span className="orion-gauge-sub-val">{density > 0 ? density.toFixed(1) : '—'} p/cm3</span>
        </div>
        {temp !== null && temp > 0 && (
          <div className="orion-gauge-sub-item">
            <span className="orion-gauge-sub-label">TEMP</span>
            <span className="orion-gauge-sub-val">{(temp / 1000).toFixed(0)}K K</span>
          </div>
        )}
        <div className="orion-gauge-sub-item">
          <span className="orion-gauge-sub-label">CLASS</span>
          <span className="orion-gauge-sub-val" style={{ color: bandColor }}>{speedClass.toUpperCase()}</span>
        </div>
      </div>
    </div>
  );
}
